<template>
  <div class="icon-text">
    <BaseIcon :type="icon" v-if="icon" />
    <slot></slot>
    <span v-if="isString">{{ text }}</span>
    <div class="icon-text__list" v-else>
      <span :key="`text-${index}`" v-for="(item, index) in text">{{ item }}</span>
    </div>
  </div>
</template>

<script>
import BaseIcon from '@base/BaseIcon'
export default {
  name: 'ElementIconText',
  components: {
    BaseIcon
  },
  props: {
    icon: {
      required: true
    },
    text: {
      type: [String, Array],
      required: false
    }
  },
  computed: {
    isString () {
      return typeof this.text === 'string'
    }
  }
}
</script>

<style lang="scss">
  .icon-text{
    display: flex;
    justify-content: flex-start;
    align-items: baseline;
    color: tint(colors("font"), 30%);
    font-weight: font-weights("medium");

    .icon{
      flex: 0 1 auto;
      margin-right: layout("spacing")/2;
      line-height: 1.3;

      &::before{
        color: tint(colors("font"), 40%);
      }
    }

    &__list{
      span{
        line-height: 1.3;
        &:not(:last-of-type){
          margin-right: layout("spacing")/4;
          &::after{
            content: ',';
          }
        }
      }
    }
  }
</style>
